import {
  GET_DAMAGE_RECIEPT_PRINT_REQUEST,
  GET_DAMAGE_RECIEPT_PRINT_SUCCESS,
  GET_DAMAGE_RECIEPT_PRINT_ERROR,
} from "./types.js";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";

export const getDamageRecieptReportPrint = (token, values) => (dispatch) => {
  dispatch({ type: GET_DAMAGE_RECIEPT_PRINT_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/damageReceiptPrint`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: values
  })
    .then((response) => {
      return dispatch({
        type: GET_DAMAGE_RECIEPT_PRINT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_DAMAGE_RECIEPT_PRINT_ERROR,
        payload: [],
      });
    });
};
